import { render, staticRenderFns } from "./PageRenderer.vue?vue&type=template&id=6ee5d36c"
import script from "./PageRenderer.vue?vue&type=script&lang=js"
export * from "./PageRenderer.vue?vue&type=script&lang=js"
import style0 from "./PageRenderer.vue?vue&type=style&index=0&id=6ee5d36c&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports